export const TENANTREGISTER_REGISTER_REQUEST = "TENANT_REGISTER_REQUEST";
export const TENANTREGISTER_REGISTER_SUCCESS = "TENANT_REGISTER_SUCCESS";
export const TENANTREGISTER_REGISTER_FAIL = "TENANT_REGISTER_FAIL";
export const TENANTREGISTER_REGISTER_RESET = "TENANT_REGISTER_RESET";

export const TENANTREGISTER_RESEND_VERIFICATION_EMAIL_REQUEST =
  "TENANT_RESEND_VERIFICATION_EMAIL_REQUEST";
export const TENANTREGISTER_RESEND_VERIFICATION_EMAIL_SUCCESS =
  "TENANT_RESEND_VERIFICATION_EMAIL_SUCCESS";
export const TENANTREGISTER_RESEND_VERIFICATION_EMAIL_FAIL =
  "TENANT_RESEND_VERIFICATION_EMAIL_FAIL";
export const TENANTREGISTER_RESEND_VERIFICATION_EMAIL_RESET =
  "TENANT_RESEND_VERIFICATION_EMAIL_RESET";

export const TENANTREGISTER_VERIFY_EMAIL_BYCODE_REQUEST =
  "TENANT_VERIFY_EMAIL_BYCODE_REQUEST";
export const TENANTREGISTER_VERIFY_EMAIL_BYCODE_SUCCESS =
  "TENANT_VERIFY_EMAIL_BYCODE_SUCCESS";
export const TENANTREGISTER_VERIFY_EMAIL_BYCODE_FAIL =
  "TENANT_VERIFY_EMAIL_BYCODE_FAIL";
export const TENANTREGISTER_VERIFY_EMAIL_BYCODE_RESET =
  "TENANT_VERIFY_EMAIL_BYCODE_RESET";

export const TENANTREGISTER_REGISTER_GOOGLE_REQUEST =
  "TENANT_REGISTER_GOOGLE_REQUEST";
export const TENANTREGISTER_REGISTER_GOOGLE_SUCCESS =
  "TENANT_REGISTER_GOOGLE_SUCCESS";
export const TENANTREGISTER_REGISTER_GOOGLE_FAIL =
  "TENANT_REGISTER_GOOGLE_FAIL";
export const TENANTREGISTER_REGISTER_GOOGLE_RESET =
  "TENANT_REGISTER_GOOGLE_RESET";

export const TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_REQUEST =
  "TENANT_VERIFY_EMAIL_BYTOKEN_REQUEST";
export const TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_SUCCESS =
  "TENANT_VERIFY_EMAIL_BYTOKEN_SUCCESS";
export const TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_FAIL =
  "TENANT_VERIFY_EMAIL_BYTOKEN_FAIL";
export const TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_RESET =
  "TENANT_VERIFY_EMAIL_BYTOKEN_RESET";
